import {dateTimeStringFromApiToDate} from "../../../index";

export class DashboardForloebManglerGodkendelseModel {
    brugerId: string;
    forloebId: string;
    forloebSlutDato: Date;

    static Build(responseModel: DashboardForloebManglerGodkendelseResponseModel): DashboardForloebManglerGodkendelseModel {
        let model = new DashboardForloebManglerGodkendelseModel();
        model.brugerId = responseModel.brugerId;
        model.forloebId = responseModel.forloebId;
        model.forloebSlutDato = dateTimeStringFromApiToDate(responseModel.forloebSlutDato)
        return model;
    }
}

export type DashboardForloebManglerGodkendelseResponseModel = {
    brugerId: string;
    forloebId: string;
    forloebSlutDato: string;
}
